import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { ArticleGridSection } from '../../../../src/components/ArticlePage/ArticleImage/styled';
import { StickySection } from '../../../../src/components/QnaPage/AskNowSection/styled';
import { getContentType, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { CardSection } from '../../ArticlePage/RelatedArticlesNew/styled';
import { QuestionContainer } from '../../QnaPage/ColumnSix/styled';
import { GridWrapper } from '../../StoreHomePage/BannersGrid/styled';
import { SimilarVideoTitle } from '../ArticlesAndVideos/styled';
import { getSearchParams } from '../common';
import CommunityBodyWrapper from './CommunityBodyWrapper';
import CommunityFilter from './CommunityFilter';
import LoadMoreButton from './LoadMoreButton';
import RecentlyAskedQuestions from './RecentlyAskedQuestions';
import UserProfile from './UserProfile';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function CommunityDiscussions(props) {
  const {
    questionData,
    recentlyAskedQues,
    filterData,
    showLoader,
    stage,
    tagId,
  } = props;
  const cardsToShowInitially = 2;
  const questionItemData = questionData;
  const [hideLoadMore, setHideLoadMore] = useState(false);
  const [selectedFilterId, setSelectedFilterId] = useState(tagId);
  const router = useRouter();
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });

  const initialData = {
    questionItemData: questionItemData,
    indexToShow: cardsToShowInitially,
  };
  const { data, error, mutate } = useSWR(
    `data_${filterData?._id}`,
    () => {
      // console.log("");
    },
    {
      fallbackData: initialData,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );
  // const [content, setContent] = useState(data);
  useEffect(() => {
    if (questionItemData?.items > 0) {
      let cardId = [];
      const data = questionItemData?.items.splice(0, cardsToShowInitially);
      data?.map((element) => {
        cardId.push(element?.content?.id);
      });
      fireServedSectionEvent(filterData?.heading, cardId, getContentType());
    }
  }, []);

  return (
    <GridWrapper parentingCommunity>
      <div>
        <SimilarVideoTitle>{filterData?.heading}</SimilarVideoTitle>
      </div>
      <ArticleGridSection stage={stage}>
        {filterData?.items?.length ? (
          <StickySection>
            <CardSection>
              <CommunityFilter
                setSelectedFilterId={setSelectedFilterId}
                showLoader={showLoader}
                filterData={filterData}
                mutate={mutate}
                indexToShow={data?.indexToShow}
              />
            </CardSection>
          </StickySection>
        ) : null}

        <div>
          {data?.questionItemData?.items?.map((item, index) => {
            if (index + 1 <= data?.indexToShow)
              return (
                <Link
                  href={{
                    pathname: item?.content?.web_url,
                    query: removeDefaultParams(router.query),
                  }}
                  passHref
                  key={`discuss_${index}`}
                  locale={false}
                  onClick={(e) => {
                    e.preventDefault();
                    setTimeout(() => {
                      router.push(
                        item?.content?.web_url + getSearchParams(),
                        '',
                        {
                          locale: getRouterLocale(router),
                        },
                      );
                    }, [200]);
                  }}
                >
                  <CardSection
                    className={
                      gridCardSignal.index === index
                        ? 'gridcardopacity transitionClass'
                        : 'transitionClass'
                    }
                    onClick={() =>
                      setGridCardSignal({
                        index: index,
                        show: true,
                      })
                    }
                  >
                    <UserProfile data={item?.content?.user_details} />
                    <QuestionContainer
                      onClick={() =>
                        fireClickedCardEvent(
                          filterData?.heading,
                          item?.content?.message?.substring(0, 98),
                          getContentType(),
                          item?.content?.id,
                          null,
                          item?.tagData?.web_url,
                        )
                      }
                    >
                      <CommunityBodyWrapper data={item} stage={stage} />
                    </QuestionContainer>
                  </CardSection>
                </Link>
              );
          })}
          {!hideLoadMore ? (
            <LoadMoreButton
              indexToShow={data?.indexToShow}
              setHideLoadMore={setHideLoadMore}
              cardsToShowInitially={cardsToShowInitially}
              postContent={data?.questionItemData}
              selectedFilterId={selectedFilterId}
              showLoader={showLoader}
              heading={filterData?.heading}
              mutate={mutate}
            />
          ) : null}
        </div>
        <div>
          <RecentlyAskedQuestions data={recentlyAskedQues} />
        </div>
      </ArticleGridSection>
    </GridWrapper>
  );
}
